// pages/app/Login.tsx — Google sign-in (spec §4). No app content is shown until authed.
import { Link } from 'react-router-dom';
import { Seo } from '../../components/Seo';
import { Wordmark } from '../../components/Wordmark';
import { Mark } from '../../components/Mark';
import { useAuth } from '../../hooks/useAuth';

function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.5a5.6 5.6 0 0 1-2.4 3.6v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.2 0 6-1.1 8-3l-3.9-3c-1.1.7-2.5 1.2-4.1 1.2-3.1 0-5.8-2.1-6.7-5H1.3v3.1A12 12 0 0 0 12 24Z"
      />
      <path fill="#FBBC05" d="M5.3 14.3a7.2 7.2 0 0 1 0-4.6V6.6H1.3a12 12 0 0 0 0 10.8l4-3.1Z" />
      <path
        fill="#EA4335"
        d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.4-3.4A12 12 0 0 0 1.3 6.6l4 3.1C6.2 6.9 8.9 4.8 12 4.8Z"
      />
    </svg>
  );
}

export function Login() {
  const { signIn } = useAuth();
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-6">
      <Seo
        title="Sign in — UPLOAD"
        description="Sign in to upload your working self."
        path="/app"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-brand/20 blur-3xl"
      />
      <div className="card relative w-full max-w-sm animate-scale-in text-center shadow-elevated">
        <Link
          to="/"
          aria-label="UPLOAD home"
          className="mx-auto flex w-fit flex-col items-center transition-opacity hover:opacity-80"
        >
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand/10 text-brand">
            <Mark className="h-8 w-8" />
          </div>
          <Wordmark className="text-2xl" />
        </Link>
        <h1 className="mt-5 text-xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-2 text-sm text-fg-muted">
          Create your account on first login. Your working self, private by default.
        </p>
        <button type="button" className="btn-secondary mt-6 w-full" onClick={() => void signIn()}>
          <GoogleGlyph />
          Continue with Google
        </button>
        <p className="mt-4 text-xs text-fg-subtle">
          By continuing you agree to our{' '}
          <a className="link" href="/terms">
            Terms
          </a>{' '}
          and{' '}
          <a className="link" href="/privacy">
            Privacy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
